import { User } from "oidc-client";
import { setGlobal } from "reactn";
import { Principal } from "../models/principal";
import SchedaBudgetDataClass from "./BudgetState";
import { SimulazioniSrlDataClass } from "./SimulazioneSrlState";
import Auth, { DevAuth, IAuth } from "../types/auth";
import { Collaboratore1DataClass, Collaboratore2DataClass, ConfrontoDataClass, DatiCollaboratore1DataClass, DatiCollaboratore2DataClass, 
    GestionePrevidenzialeDataClass, ImprenditoreProfessionistaDataClass, IrpefCollaboratore1DataClass, IrpefCollaboratore2DataClass, 
    IrpefImprenditoreDataClass, LiquidazioneIrpefDataClass, RedditoContributiImpostaDataClass, RegimeForfettarioDataClass, RegimeNormaleDataClass, 
    TipoImpresa, TipoPrevidenza, TipoRegime } from "../types/types";
import { Company } from "../models/company";
import { addReducers } from "./reducers";
import { Agency } from "../models/agency";
import { Applicazione } from "../models/applicazione";
import { WhatsNew } from "../models/whatsNew";
import { Telematico } from "../models/telematico";

export enum InEditingMode {
    Read,
    Edit,
    New
}
export interface InEditingType {
    modified: boolean,
    mode: InEditingMode,
}
export interface InEditingCompany extends InEditingType {company: Company, }
export interface InEditingAgency extends InEditingType {agency: Agency, }
export interface InEditingPrincipal extends InEditingType {principal: Principal, }
export interface InEditingWhatsNew extends InEditingType {whatsNew: WhatsNew, }
export type EditStatus = 'Invalid' | 'Pristine' | 'New' | 'Modified';

export type UsersFilterType = {
    username: string,
    name: string,
    surname: string,
    role: string,
    agencyId: number | null,
}
export type AgencyTypeFilter = {
    name: string,
    code: string,
    vatNumber: string,
}
export interface IGlobalState {
    prov: string;
    devAuth: DevAuth;
    auth: IAuth;
    loadingAuth: boolean;
    globalWait: boolean;
    ip: string;
    identity: Principal | null;
    drawerIsOpen: boolean;
    drawerMobileIsOpen: boolean;
    application: number;  // per caricare le varie lookup
    drawerIndex: number;  // per caricare le varie lookup
    drawerMobileIndex: number;
    userLogged: string | undefined;
    applicationList: Applicazione[];
    title: string;
    licenseNumber: number;
    // user: User | null;
    isBusy: boolean;
    companies: Company[],
    agencies: Agency[],
    principals: Principal[],
    whatsNews: WhatsNew[],
    telematicos: Telematico[],
    companyPagination: typeof paginationInitialValues,
    agencyPagination: typeof paginationInitialValues,
    principalPagination: typeof paginationInitialValues,
    whatsNewPagination: typeof paginationInitialValues,
    telamaticoPagination: typeof paginationInitialValues,
    loadingCompanies: boolean,
    loadingAgencies: boolean,
    loadingPrincipals: boolean,
    loadingWhatsNews: boolean,
    loadingTelematico: boolean,
    filteredCompanies: Company[],
    filteredAgencies: Agency[],
    filteredPrincipals: Principal[],
    filteredWhatsNews: WhatsNew[],
    filteredTelematico: Telematico[],
    currentEditCompany: InEditingCompany | null,
    currentEditAgency: InEditingAgency | null,
    currentEditPrincipal: InEditingPrincipal | null,
    currentEditWhatsNew: InEditingWhatsNew | null,
    currentEditCompanyStatus: EditStatus,
    currentEditAgencyStatus: EditStatus,
    currentEditPrincipalStatus: EditStatus,
    currentEditWhatsNewStatus: EditStatus,
    usersFilter: UsersFilterType,
    agencyFilter: AgencyTypeFilter,
    exportingReport: boolean,
}

const userManager = Auth.getDefaultUserManager();
const paginationInitialValues = { rows: 0, rowsPerPage: 20, page: 0, direction: 'forward', querySurname: '' , queryId: 0 };

export const initialGlobalState: Partial<IGlobalState> = {
    prov: "",
    devAuth: {
        prov: "44",
        username: "siasassi",
        sede: "057",
    },
    loadingAuth: false,
    auth: {
        userManager,
        user: null,
        authData: null,
    },
    globalWait: false,
    ip: "0.0.0.1",
    // identity
    drawerIsOpen: false,
    drawerMobileIsOpen: false,
    drawerIndex: 0,
    drawerMobileIndex: 0,
    userLogged: undefined,
    isBusy: false,
    companyPagination: paginationInitialValues,
    agencyPagination: paginationInitialValues,
    principalPagination: paginationInitialValues,
    whatsNewPagination: paginationInitialValues,
    telamaticoPagination: paginationInitialValues,
    applicationList: [],
    title: '',
    licenseNumber: 0,
    //Company
    loadingCompanies: false,
    companies: [],
    filteredCompanies: [],
    currentEditCompany: null,
    currentEditCompanyStatus: 'Pristine',
    // Agency
    loadingAgencies: false,
    agencies: [],
    filteredAgencies: [],
    currentEditAgency: null,
    currentEditAgencyStatus: 'Pristine',
    // Principal
    loadingPrincipals: false,
    principals: [],
    filteredPrincipals: [],
    currentEditPrincipal: null,
    currentEditPrincipalStatus: 'Pristine',
    usersFilter: { username: '', name: '', surname: '', role: '', agencyId: null},
    agencyFilter: {name: '', code: '', vatNumber: ''},
    // WahtsNew
    loadingWhatsNews: false,
    whatsNews: [],
    filteredWhatsNews: [],
    currentEditWhatsNew: null,
    currentEditWhatsNewStatus: 'Pristine',
    // Telematico
    loadingTelematico: false,
    telematicos: [],
    filteredTelematico: [],
}

export const aliquotaIRES = 24;

export type Model = IMyAppState;

export interface IMyAppState {
    id: number;
    loading: boolean;
    nomeCognome: string;
    tipologia: TipoImpresa;
    famigliare: boolean;
    quotaCollab1: number;
    quotaCollab2: number;
    gestionePrevidenziale: GestionePrevidenzialeDataClass;
    regimeForfettario: RegimeForfettarioDataClass;
    redditoContributiImposta: RedditoContributiImpostaDataClass;
    regimeNormale: RegimeNormaleDataClass;
    liquidazioneIrpef: LiquidazioneIrpefDataClass;
    datiCollaboratore1: DatiCollaboratore1DataClass;
    datiCollaboratore2: DatiCollaboratore2DataClass;
    imprenditoreProfessionista: ImprenditoreProfessionistaDataClass;
    collaboratore1: Collaboratore1DataClass;
    collaboratore2: Collaboratore2DataClass;
    irpefImprenditore: IrpefImprenditoreDataClass;
    irpefCollaboratore1: IrpefCollaboratore1DataClass;
    irpefCollaboratore2: IrpefCollaboratore2DataClass;
    confronto: ConfrontoDataClass;
    // flatTax: FlatTaxDataClass;
    // simulazioniSrl: SimulazioniSrlDataClass;
    // budget: SchedaBudgetDataClass;
}

export const initialState: IMyAppState = {
    id: 0,
    loading: false,
    nomeCognome: "",
    famigliare: false,
    tipologia: TipoImpresa.Undefined,
    quotaCollab1: 0,
    quotaCollab2: 0,
    gestionePrevidenziale: { tipoPrevidenza: TipoPrevidenza.Undefined, aliquotaSep: 0, cassaProfessionale: false },

    regimeForfettario: { gruppo: 0, impostaSost: 0, percentualeRedditivita: 0, showWarning: false },

    redditoContributiImposta: {
        ricavi: 0,
        riduzione35: false,
        rivalsa: false,
        contributiIvsDeducibili: 0,
        contributiCassaProf: 0,
        redditoLordo: 0,
        redditoPerIvs: 0,
        contributiIvs: 0,
        redditoIvsCollab1: 0,
        contribIvsCollab1: 0,
        redditoIvsCollab2: 0,
        contribIvsCollab2: 0,
        contributiIvsNetti: 0,
        contributiGestSep: 0,
        redditoNetto: 0,
        impostaSostitutiva: 0,
        warningContributi35: false,
        mesiWarningContributi35Netti: 0,
        mesiWarningContributi35Collab1: 0,
        mesiWarningContributi35Collab2: 0,
    },

    regimeNormale:
    {
        determinazioneDelReddito_B81: "",
        determinazioneDelReddito_B82: "",
        determinazioneDelReddito_B83: "",
        determinazioneDelReddito_B84: "",
        determinazioneDelReddito_B85: "",
        determinazioneDelReddito_B86: "",
        determinazioneDelReddito_B87: "",
        determinazioneDelReddito_B88: "",
        determinazioneDelReddito_B89: "",
        determinazioneDelReddito_B90: "",
        determinazioneDelReddito_B91: "",
        determinazioneDelReddito_B92: "",
        determinazioneDelReddito_B93: "",
        determinazioneDelReddito_G81: 0,
        determinazioneDelReddito_G82: 0,
        determinazioneDelReddito_G83: 0,
        determinazioneDelReddito_G84: 0,
        determinazioneDelReddito_G85: 0,
        determinazioneDelReddito_G86: 0,
        determinazioneDelReddito_G87: 0,
        determinazioneDelReddito_G88: 0,
        determinazioneDelReddito_G89: 0,
        determinazioneDelReddito_G90: 0,
        determinazioneDelReddito_G91: 0,
        determinazioneDelReddito_G92: 0,
        determinazioneDelReddito_G93: 0,
        determinazioneDelValoreDellaProduzioneNetta_N81: false,
        determinazioneDelValoreDellaProduzioneNetta_I82: "",
        determinazioneDelValoreDellaProduzioneNetta_N82: 0,
        determinazioneDelValoreDellaProduzioneNetta_I83: "",
        determinazioneDelValoreDellaProduzioneNetta_N83: 0,
        determinazioneDelValoreDellaProduzioneNetta_I84: "",
        determinazioneDelValoreDellaProduzioneNetta_N84: 0,
        determinazioneDelValoreDellaProduzioneNetta_I85: "",
        determinazioneDelValoreDellaProduzioneNetta_N85: 0,
        determinazioneDelValoreDellaProduzioneNetta_I86: "",
        determinazioneDelValoreDellaProduzioneNetta_N86: 0,
        determinazioneDelValoreDellaProduzioneNetta_I88: "",
        determinazioneDelValoreDellaProduzioneNetta_L88: 0,
        determinazioneDelValoreDellaProduzioneNetta_I89: "",
        determinazioneDelValoreDellaProduzioneNetta_N89: 0,
        determinazioneDelValoreDellaProduzioneNetta_L91: 0,
        determinazioneDelValoreDellaProduzioneNetta_L92: 0
    },

    liquidazioneIrpef: {
        redditiDiversiDaImpresa_LavAutonomo_E98: 0,
        redditiDiversiDaImpresa_LavAutonomo_E99: 0,
        redditiDiversiDaImpresa_LavAutonomo_E100: 0,
        redditiDiversiDaImpresa_LavAutonomo_E101: 0,
        redditiDiversiDaImpresa_LavAutonomo_E102: 0,
        redditiDiversiDaImpresa_LavAutonomo_E103: 0,
        redditiDiversiDaImpresa_LavAutonomo_E104: 0,
        redditiDiversiDaImpresa_LavAutonomo_E105: 0,
        altriDatiPersonali_H99: false,
        altriDatiPersonali_J99: 0,
        altriDatiPersonali_L101: 0,
        altriDatiPersonali_L102: 0,
        altriDatiPersonali_I104: 0,
        altriDatiPersonali_M104: 0,
        altriDatiPersonali_L99: 0
    },

    datiCollaboratore1: {
        nomeCognome1: "",
        quotaReddito1: 0,
        redditiDiversiDallaPartecipazione_E111: 0,
        redditiDiversiDallaPartecipazione_E112: 0,
        redditiDiversiDallaPartecipazione_E113: 0,
        redditiDiversiDallaPartecipazione_E114: 0,
        redditiDiversiDallaPartecipazione_E115: 0,
        redditiDiversiDallaPartecipazione_E116: 0,
        redditiDiversiDallaPartecipazione_E117: 0,
        redditiDiversiDallaPartecipazione_E119: 0,
        altriDatiPersonali_H112: false,
        altriDatiPersonali_J112: 0,
        altriDatiPersonali_L112: 0,
        altriDatiPersonali_L114: 0,
        altriDatiPersonali_L115: 0,
        altriDatiPersonali_I117: 0,
        altriDatiPersonali_M117: 0,
        altriDatiPersonali_J118: 0
    },

    datiCollaboratore2:
    {
        nomeCognome2: "",
        quotaReddito2: 0,
        redditiDiversiDaImpresa_LavAutonomo_E123: 0,
        redditiDiversiDaImpresa_LavAutonomo_E124: 0,
        redditiDiversiDaImpresa_LavAutonomo_E125: 0,
        redditiDiversiDaImpresa_LavAutonomo_E126: 0,
        redditiDiversiDaImpresa_LavAutonomo_E127: 0,
        redditiDiversiDaImpresa_LavAutonomo_E128: 0,
        redditiDiversiDaImpresa_LavAutonomo_E129: 0,
        redditiDiversiDaImpresa_LavAutonomo_E131: 0,
        altriDatiPersonali_H124: false,
        altriDatiPersonali_J124: 0,
        altriDatiPersonali_L124: 0,
        altriDatiPersonali_L126: 0,
        altriDatiPersonali_L127: 0,
        altriDatiPersonali_I129: 0,
        altriDatiPersonali_M129: 0,
        altriDatiPersonali_J130: 0
    },

    imprenditoreProfessionista: {
        redditi_E18: 0,
        redditi_E19: 0,
        redditi_I8: 0,
        redditi_I9: 0,
        redditi_I11: 0,
        redditi_I12: 0,
        redditi_I13: 0,
        redditi_I14: 0,
        redditi_I16: 0,
        redditi_M12: 0,
        redditi_M16: 0,
        redditi_K16: 0
    },

    collaboratore1: {
        rivalsaContrIvs_H33: 0,
        redditi_E46: 0,
        redditi_E47: 0,
        oneriDeducibiliredditi_I35: 0,
        redditoImponibile_I36: 0,
        irpefLorda_I37: 0,
        familiari_I39: 0,
        lavDip_I40: 0,
        pensione_I41: 0,
        lavNonDip_I42: 0,
        totDetr_I44: 0,
        irpefNetta_M40: 0,
        regionale_K44: 0,
        comunale_M44: 0
    },

    collaboratore2: {
        rivalsaContrIvs_H60: 0,
        redditi_E73: 0,
        redditi_E74: 0,
        oneriDeducibiliredditi_I62: 0,
        redditoImponibile_I63: 0,
        irpefLorda_I64: 0,
        familiari_I66: 0,
        lavDip_I67: 0,
        pensione_I68: 0,
        lavNonDip_I69: 0,
        totDetr_I71: 0,
        irpefNetta_M67: 0,
        regionale_K71: 0,
        comunale_M71: 0,
    },

    irpefImprenditore: {
        E12: 0,
        E20: 0,
        E21: 0,
        I29: 0,
        I9: 0,
        I10: 0,
        I11: 0,
        I13: 0,
        I14: 0,
        I15: 0,
        I16: 0,
        I18: 0,
        M14: 0,
        M18: 0,
        K18: 0
    },

    irpefCollaboratore1: {
        H35: 0,
        E49: 0,
        E48: 0,
        I37: 0,
        I38: 0,
        I39: 0,
        I41: 0,
        I42: 0,
        I43: 0,
        I44: 0,
        I46: 0,
        M42: 0,
        M46: 0,
        K46: 0
    },

    irpefCollaboratore2: {
        H62: 0,
        E75: 0,
        E76: 0,
        I64: 0,
        I65: 0,
        I66: 0,
        I68: 0,
        I69: 0,
        I70: 0,
        I71: 0,
        I73: 0,
        M69: 0,
        M73: 0,
        K73: 0
    },

    confronto: {
        D36: 0,
        G33: 0,
        K28_contributi: 0,
        D28_contributi: 0,
        K27_imposte: 0,
        D27_imposte: 0,
        G6_contributi: 0,
        G25_totale: 0,
        M25_totale: 0,
        M78: 0,
        M77: 0,
        M76: 0,
        G76: 0,
        M75: 0,
        G77: 0,
        G78: 0,
        G75: 0,
        M74: 0,
        G74: 0,
        M73: 0,
        M72: 0,
        M71: 0,
        M70: 0,
        M69: 0,
        G69: 0,
        M68: 0,
        M67: 0,
        G67: 0,
        M66: 0,
        G66: 0,
        B79: "",
        E79: false,
        G79: 0,
        G81: 0,
        E81: false,
        B81: "",
        G80: 0,
        E80: false,
        B80: "",
        G82: 0,
        E82: false,
        B82: "",
        G83: 0,
        E83: false,
        B83: "",
        G84: 0,
        E84: false,
        B84: "",
        M81: 0,
        L81: false,
        I81: "",
        M80: 0,
        L80: false,
        I80: "",
        M79: 0,
        L79: false,
        I79: "",
        M83: 0,
        L83: false,
        I83: "",
        M82: 0,
        L82: false,
        I82: "",
        M84: 0,
        L84: false,
        I84: "",
        M86: 0,
        G86: 0
    },

    // flatTax: {
    //     datiInformazioniInizialiFt: {
    //         D43: "",
    //         D45: TipoImpresa.Undefined,
    //         D47: false,
    //         D48: 0,
    //         D49: 0,
    //         E94: "",
    //         E106: ""
    //     },
    //     gestionePrevidenzialeFt: {
    //         M48: false,
    //         M47: 0,
    //         M46: TipoPrevidenza.Undefined
    //     },
    //     determinazioneDelRedditoFt: {
    //         G54: 0,
    //         B54: "",
    //         G55: 0,
    //         B55: "",
    //         G56: 0,
    //         B56: "",
    //         G57: 0,
    //         B57: "",
    //         G58: 0,
    //         B58: "",
    //         G59: 0,
    //         B59: "",
    //         G60: 0,
    //         B60: "",
    //         G61: 0,
    //         B61: "",
    //         G62: 0,
    //         B62: "",
    //         G66: 0,
    //         B66: "",
    //         G65: 0,
    //         B65: "",
    //         G64: 0,
    //         B64: "",
    //         G63: 0,
    //         B63: ""
    //     },
    //     irapRegimeNormaleFt: {
    //         G69: false,
    //         G70: 0,
    //         B70: "",
    //         G71: 0,
    //         B71: "",
    //         G72: 0,
    //         B72: "",
    //         G73: 0,
    //         B73: "",
    //         G74: 0,
    //         B74: "",
    //         E76: 0,
    //         B76: "",
    //         G77: 0,
    //         B77: ""
    //     },
    //     contributiFt: {
    //         L61: 0,
    //         L60: 0,
    //         L62: 0,
    //         J59: false,
    //         N58: 0,
    //         N57: 0,
    //         N56: 0,
    //         N55: 0,
    //         K56: 0,
    //         K55: 0,
    //     },
    //     impostaSostitutivaFt: {
    //         L66: 0,
    //         L65: 0
    //     },
    //     liquidazioneIrpefDatiImprenditoreProfessionistaFt: {
    //         I88: 0,
    //         L86: 0,
    //         L85: 0,
    //         L83: 0,
    //         J83: 0,
    //         E82: 0,
    //         E83: 0,
    //         E84: 0,
    //         E85: 0,
    //         E86: 0,
    //         E87: 0,
    //         E88: 0,
    //         E89: 0,
    //         M88: 0,
    //         H83: false
    //     },
    //     impresaFamiliareFt: {
    //         M114: 0,
    //         I114: 0,
    //         L112: 0,
    //         L111: 0,
    //         L109: 0,
    //         J109: 0,
    //         E116: 0,
    //         E114: 0,
    //         E113: 0,
    //         E112: 0,
    //         E111: 0,
    //         E110: 0,
    //         E109: 0,
    //         E108: 0,
    //         M102: 0,
    //         I102: 0,
    //         L100: 0,
    //         L99: 0,
    //         L97: 0,
    //         J97: 0,
    //         E96: 0,
    //         E97: 0,
    //         E98: 0,
    //         E99: 0,
    //         E100: 0,
    //         E101: 0,
    //         E102: 0,
    //         E104: 0,
    //         K94: 0,
    //         H97: false,
    //         H109: false
    //     },
    //     imprenditoreProfessionistaFtIrpef: {
    //         E19: 0,
    //         E18: 0,
    //         I8: 0,
    //         I9: 0,
    //         I11: 0,
    //         I12: 0,
    //         I13: 0,
    //         I14: 0,
    //         I16: 0,
    //         M12: 0,
    //         M16: 0,
    //         K16: 0
    //     },
    //     collaboratore1FtIrpef: {
    //         H33: 0,
    //         E47: 0,
    //         E46: 0,
    //         I35: 0,
    //         I39: 0,
    //         I37: 0,
    //         I36: 0,
    //         I40: 0,
    //         I41: 0,
    //         I42: 0,
    //         I44: 0,
    //         M44: 0,
    //         K44: 0,
    //         M40: 0
    //     },
    //     collaboratore2FtIrpef: {
    //         F58: 0,
    //         E62: 0,
    //         E63: 0,
    //         E64: 0,
    //         E66: 0,
    //         E67: 0,
    //         E68: 0,
    //         E69: 0,
    //         E71: 0,
    //         E73: 0,
    //         E74: 0,
    //         H60: 0,
    //         I62: 0,
    //         I63: 0,
    //         I64: 0,
    //         I66: 0,
    //         I67: 0,
    //         I68: 0,
    //         I69: 0,
    //         I70: 0,
    //         I71: 0,
    //         K71: 0,
    //         M67: 0,
    //         M71: 0
    //     },
    //     imprenditoreProfessionistaFtTuttoIrpef: {
    //         H7: 0,
    //         E12: 0,
    //         E21: 0,
    //         E20: 0,
    //         I9: 0,
    //         I10: 0,
    //         I11: 0,
    //         I13: 0,
    //         I14: 0,
    //         I15: 0,
    //         I16: 0,
    //         I18: 0,
    //         M14: 0,
    //         M18: 0,
    //         K18: 0
    //     },
    //     collaboratore1FtTuttoIrpef: {
    //         E48: 0,
    //         E49: 0,
    //         I37: 0,
    //         I38: 0,
    //         I39: 0,
    //         I41: 0,
    //         I42: 0,
    //         I43: 0,
    //         I44: 0,
    //         I46: 0,
    //         M46: 0,
    //         M42: 0,
    //         K46: 0
    //     },
    //     collaboratore2FtTuttoIrpef: {
    //         E76: 0,
    //         E75: 0,
    //         I64: 0,
    //         I66: 0,
    //         I65: 0,
    //         I68: 0,
    //         I69: 0
    //     }
    // },

    // simulazioniSrl: {
    //     datiSimulazioniSrl: {
    //         M198: 0,
    //         M196: "Non definito",
    //         J198: 0,
    //         J197: 0,
    //         J196: false,
    //         L194: 0,
    //         L193: 0,
    //         N192: 0,
    //         L191: 0,
    //         J191: 0,
    //         H191: false,
    //         E199: 0,
    //         E197: 0,
    //         E196: 0,
    //         E195: 0,
    //         E194: 0,
    //         E193: 0,
    //         E192: 0,
    //         E191: 0,
    //         E190: 0,
    //         M184: 0,
    //         M182: "Non definito",
    //         J184: 0,
    //         J183: 0,
    //         J182: false,
    //         L180: 0,
    //         L179: 0,
    //         N178: 0,
    //         L177: 0,
    //         J177: 0,
    //         H177: false,
    //         E185: 0,
    //         E183: 0,
    //         E182: 0,
    //         E181: 0,
    //         E180: 0,
    //         E179: 0,
    //         E178: 0,
    //         E177: 0,
    //         E176: 0,
    //         M169: 0,
    //         M167: "Non definito",
    //         J169: 0,
    //         J168: 0,
    //         J167: false,
    //         L165: 0,
    //         L164: 0,
    //         N163: 0,
    //         L162: 0,
    //         J162: 0,
    //         H162: false,
    //         E170: 0,
    //         E168: 0,
    //         E167: 0,
    //         E166: 0,
    //         E165: 0,
    //         E164: 0,
    //         E163: 0,
    //         E162: 0,
    //         E161: 0,
    //         M155: 0,
    //         M153: "Non definito",
    //         J155: 0,
    //         J154: 0,
    //         J153: false,
    //         L151: 0,
    //         L150: 0,
    //         N149: 0,
    //         L148: 0,
    //         J148: 0,
    //         H148: false,
    //         E156: 0,
    //         E154: 0,
    //         E153: 0,
    //         E152: 0,
    //         E151: 0,
    //         E150: 0,
    //         E149: 0,
    //         E148: 0,
    //         E147: 0,
    //         M139: "Non definito",
    //         J139: false,
    //         M141: 0,
    //         J141: 0,
    //         J140: 0,
    //         L137: 0,
    //         L136: 0,
    //         N135: 0,
    //         E142: 0,
    //         E140: 0,
    //         E139: 0,
    //         E138: 0,
    //         E137: 0,
    //         E136: 0,
    //         E135: 0,
    //         E134: 0,
    //         E133: 0,
    //         L119: 0,
    //         J119: 0,
    //         H119: false,
    //         G48: "",
    //         C52: "",
    //         K52: 0,
    //         K53: 0,
    //         C53: "",
    //         K54: 0,
    //         C54: "",
    //         K55: 0,
    //         C55: "",
    //         K56: 0,
    //         C56: "",
    //         K57: 0,
    //         C57: "",
    //         K62: 0,
    //         K63: 0,
    //         K64: 0,
    //         D65: aliquotaIRES,
    //         D72: 0,
    //         G74: 0,
    //         G75: 0,
    //         G76: 0,
    //         G77: 0,
    //         G78: 0,
    //         G79: 0,
    //         D83: 0,
    //         D88: 0,
    //         D89: 0,
    //         G91: 0,
    //         G92: 0,
    //         G93: 0,
    //         G94: 0,
    //         G95: 0,
    //         G96: 0,
    //         G104: 0,
    //         G105: 0,
    //         G106: 0,
    //         G107: 0,
    //         G108: 0,
    //         G109: 0,
    //         D102: 0,
    //         E111: 0,
    //         L52: "",
    //         H74: "",
    //         H91: "",
    //         H104: "",
    //         J111: false,
    //         H134: false,
    //         E127: 0,
    //         E125: 0,
    //         E124: 0,
    //         E123: 0,
    //         E122: 0,
    //         E121: 0,
    //         E120: 0,
    //         E119: 0,
    //         E118: 0,
    //         J134: 0,
    //         L134: 0,
    //         N120: 0,
    //         L121: 0,
    //         L122: 0,
    //         J124: false,
    //         J126: 0,
    //         J125: 0,
    //         M124: "Non definito",
    //         M126: 0
    //     },
    //     normaleSimulazioniSrl: {
    //         I11: 0,
    //         I12: 0,
    //         I13: 0,
    //         I14: 0,
    //         E38: 0,
    //         E39: 0,
    //         G23: 0,
    //         H23: 0,
    //         K37: 0,
    //         M37: 0,
    //         I35: 0,
    //         I37: 0,
    //         I33: 0,
    //         I31: 0,
    //         I30: 0,
    //         I29: 0,
    //         I27: 0,
    //         I26: 0,
    //         I25: 0,
    //         I56: 0,
    //         I57: 0,
    //         I58: 0,
    //         I60: 0,
    //         I61: 0,
    //         I62: 0,
    //         I64: 0,
    //         I66: 0,
    //         I68: 0,
    //         M68: 0,
    //         K68: 0,
    //         H54: 0,
    //         G54: 0,
    //         E69: 0,
    //         E70: 0,
    //         E73: 0,
    //         E100: 0,
    //         E101: 0,
    //         G85: 0,
    //         H85: 0,
    //         I87: 0,
    //         I88: 0,
    //         I89: 0,
    //         I91: 0,
    //         I92: 0,
    //         I93: 0,
    //         I95: 0,
    //         I97: 0,
    //         K99: 0,
    //         M99: 0,
    //         I34: 0,
    //         I65: 0,
    //     },
    //     soloCompSimulazioniSrl: {
    //         M98: 0,
    //         K98: 0,
    //         I98: 0,
    //         I96: 0,
    //         I94: 0,
    //         I92: 0,
    //         I91: 0,
    //         I90: 0,
    //         I88: 0,
    //         I87: 0,
    //         I86: 0,
    //         H84: 0,
    //         G84: 0,
    //         E100: 0,
    //         E99: 0,
    //         E87: 0,
    //         D87: 0,
    //         M67: 0,
    //         K67: 0,
    //         I67: 0,
    //         I65: 0,
    //         I63: 0,
    //         I61: 0,
    //         I60: 0,
    //         I59: 0,
    //         I57: 0,
    //         I56: 0,
    //         I55: 0,
    //         H53: 0,
    //         G53: 0,
    //         E69: 0,
    //         E68: 0,
    //         E56: 0,
    //         D56: 0,
    //         M36: 0,
    //         K36: 0,
    //         I36: 0,
    //         I34: 0,
    //         I32: 0,
    //         I30: 0,
    //         I29: 0,
    //         I28: 0,
    //         I26: 0,
    //         I25: 0,
    //         I24: 0,
    //         H22: 0,
    //         G22: 0,
    //         E38: 0,
    //         E37: 0,
    //         E25: 0,
    //         D25: 0,
    //         I14: 0,
    //         I13: 0,
    //         I11: 0,
    //         I8: 0
    //     },
    //     compDivSimulazioniSrl: {
    //         M37: 0,
    //         K37: 0,
    //         M33: 0,
    //         K33: 0,
    //         I37: 0,
    //         I35: 0,
    //         I33: 0,
    //         I31: 0,
    //         I30: 0,
    //         I29: 0,
    //         I27: 0,
    //         I26: 0,
    //         I25: 0,
    //         H23: 0,
    //         G23: 0,
    //         M25: 0,
    //         E39: 0,
    //         E38: 0,
    //         E31: 0,
    //         E26: 0,
    //         D26: 0,
    //         I14: 0,
    //         I13: 0,
    //         I11: 0,
    //         I8: 0,
    //         D57: 0,
    //         E57: 0,
    //         E62: 0,
    //         E69: 0,
    //         I93: 0,
    //         I92: 0,
    //         I91: 0,
    //         I89: 0,
    //         I88: 0,
    //         I87: 0,
    //         H85: 0,
    //         G85: 0,
    //         E101: 0,
    //         E100: 0,
    //         E93: 0,
    //         E88: 0,
    //         D88: 0,
    //         M68: 0,
    //         K68: 0,
    //         E70: 0,
    //         G54: 0,
    //         H54: 0,
    //         I56: 0,
    //         I57: 0,
    //         I58: 0,
    //         I60: 0,
    //         I61: 0,
    //         I62: 0,
    //         I64: 0,
    //         I66: 0,
    //         I68: 0,
    //         M56: 0,
    //         K64: 0,
    //         M64: 0,
    //         M99: 0,
    //         K99: 0,
    //         M95: 0,
    //         K95: 0,
    //         M87: 0,
    //         I99: 0,
    //         I97: 0,
    //         I95: 0,
    //     },
    //     traspSimulazioniSrl: {
    //         M37: 0,
    //         K37: 0,
    //         I37: 0,
    //         I35: 0,
    //         I33: 0,
    //         I31: 0,
    //         I30: 0,
    //         I29: 0,
    //         I27: 0,
    //         I26: 0,
    //         I25: 0,
    //         H23: 0,
    //         G23: 0,
    //         E39: 0,
    //         E38: 0,
    //         E32: 0,
    //         I11: 0,
    //         M100: 0,
    //         K100: 0,
    //         I100: 0,
    //         I98: 0,
    //         I96: 0,
    //         I94: 0,
    //         I93: 0,
    //         I92: 0,
    //         I90: 0,
    //         I89: 0,
    //         I88: 0,
    //         H86: 0,
    //         G86: 0,
    //         E101: 0,
    //         E102: 0,
    //         E95: 0,
    //         M69: 0,
    //         K69: 0,
    //         I69: 0,
    //         I67: 0,
    //         I65: 0,
    //         I63: 0,
    //         I62: 0,
    //         I61: 0,
    //         I59: 0,
    //         I58: 0,
    //         I57: 0,
    //         H55: 0,
    //         G55: 0,
    //         E71: 0,
    //         E70: 0,
    //         E64: 0,
    //     },
    //     soloDivSimulazioniSrl: {
    //         K37: 0,
    //         M37: 0,
    //         M33: 0,
    //         K33: 0,
    //         M25: 0,
    //         I37: 0,
    //         I35: 0,
    //         I31: 0,
    //         I33: 0,
    //         I30: 0,
    //         I29: 0,
    //         I27: 0,
    //         I26: 0,
    //         I25: 0,
    //         H23: 0,
    //         G23: 0,
    //         E39: 0,
    //         E38: 0,
    //         E31: 0,
    //         I14: 0,
    //         I13: 0,
    //         I11: 0,
    //         M99: 0,
    //         K99: 0,
    //         M95: 0,
    //         K95: 0,
    //         M87: 0,
    //         I99: 0,
    //         I97: 0,
    //         I95: 0,
    //         I93: 0,
    //         I92: 0,
    //         I91: 0,
    //         I89: 0,
    //         I88: 0,
    //         I87: 0,
    //         H85: 0,
    //         G85: 0,
    //         E101: 0,
    //         E100: 0,
    //         E93: 0,
    //         M68: 0,
    //         K68: 0,
    //         M64: 0,
    //         K64: 0,
    //         M56: 0,
    //         I68: 0,
    //         I66: 0,
    //         I64: 0,
    //         I62: 0,
    //         I61: 0,
    //         I60: 0,
    //         I58: 0,
    //         I57: 0,
    //         I56: 0,
    //         H54: 0,
    //         G54: 0,
    //         E70: 0,
    //         E69: 0,
    //         E62: 0,
    //     },
    //     traspCompSimulazioniSrl: {
    //         M36: 0,
    //         K36: 0,
    //         I36: 0,
    //         I34: 0,
    //         I32: 0,
    //         I30: 0,
    //         I29: 0,
    //         I28: 0,
    //         I26: 0,
    //         I25: 0,
    //         I24: 0,
    //         H22: 0,
    //         G22: 0,
    //         E38: 0,
    //         E37: 0,
    //         E31: 0,
    //         E25: 0,
    //         D25: 0,
    //         I12: 0,
    //         I11: 0,
    //         I8: 0
    //     }
    // },

    // budget: {
    //     informazioniCostiDiAvvio: {
    //         nomeDitta: "",
    //         tipologia: TipoImpresa.Undefined,
    //         attivita: "",
    //         regime: TipoRegime.Undefined,
    //         E17_macchinari: 0,
    //         E16_fabbricato: 0,
    //         E37_speseVive_AcquistoAzienda: 0,
    //         E38_speseVive_AffittoAzienda: 0,
    //         E39_speseVive_AttoCostSocieta: 0,

    //         E40_speseVive_IscrizioneRegistroImprese: 0,
    //         F40_speseVive_IscrizioneRegistroImprese: 0,
    //         G40_speseVive_IscrizioneRegistroImprese: 0,

    //         E41_speseVive_IscrizioneAlbo: 0,
    //         F41_speseVive_IscrizioneAlbo: 0,
    //         G41_speseVive_IscrizioneAlbo: 0,

    //         E42_speseVive_AutorizzazioniPermessi: 0,

    //     },
    //     contoEconomico: {

    //     },
    //     forfetario: {

    //     }
    // }
}

export const initialStateBudget: SchedaBudgetDataClass = {
    loading: false,
    id: 0,
    informazioniCostiDiAvvio: {
        nomeDitta: "",
        tipologia: TipoImpresa.Undefined,
        attivita: "",
        regime: TipoRegime.Normale,
        E16_fabbricato: 0,
        E17_macchinari: 0,
        E18_attrezzature: 0,
        E19_macchinari: 0,
        E20_mobili: 0,
        E21_furgoni: 0,
        E22_autovetture: 0,
        E23_immateriali: 0,
        E24_altro: 0,
        E25_totale: 0,
        E37_speseVive_AcquistoAzienda: 0,
        F37_consEst_AcquistoAzienda: 0,
        I37_consInt_AcquistoAzienda: 0,
        E38_speseVive_AffittoAzienda: 0,
        F38_consEst_AffittoAzienda: 0,
        I38_consInt_AffittoAzienda: 0,
        E39_speseVive_AttoCostSocieta: 0,
        F39_consEst_AttoCostSocieta: 0,
        I39_consInt_AttoCostSocieta: 0,
        E40_speseVive_IscrizioneRegistroImprese: 0,
        F40_consEst_IscrizioneRegistroImprese: 0,
        I40_consInt_IscrizioneRegistroImprese: 0,
        E41_speseVive_IscrizioneAlbo: 0,
        F41_consEst_IscrizioneAlbo: 0,
        I41_consInt_IscrizioneAlbo: 0,
        E42_speseVive_AutorizzazioniPermessi: 0,
        F42_consEst_AutorizzazioniPermessi: 0,
        I42_consInt_AutorizzazioniPermessi: 0,
        E43_speseVive_Locali: 0,
        F43_consEst_Locali: 0,
        I43_consInt_Locali: 0,
        E44_speseVive_Privacy: 0,
        F44_consEst_Privacy: 0,
        I44_consInt_Privacy: 0,
        E45_speseVive_Dlgs812008: 0,
        F45_consEst_Dlgs812008: 0,
        I45_consInt_Dlgs812008: 0,
        E46_speseVive_HACCP: 0,
        F46_consEst_HACCP: 0,
        I46_consInt_HACCP: 0,
        E47_speseVive_Ambiente: 0,
        F47_consEst_Ambiente: 0,
        I47_consInt_Ambiente: 0,
        E48_speseVive_Informatici: 0,
        F48_consEst_Informatici: 0,
        I48_consInt_Informatici: 0,
        E49_speseVive_Altro1: 0,
        F49_consEst_Altro1: 0,
        I49_consInt_Altro1: 0,
        E50_speseVive_Altro2: 0,
        F50_consEst_Altro2: 0,
        I50_consInt_Altro2: 0,
        I51_consulenze_interne: 0,
        F51_consulenze_esterne_provvigioni: 0,
        E51_parziali_spese_vive: 0,
        E52_totale_costi_iniziali: 0,
        K16_fabbricato: 0,
        K17_macchinari: 0,
        K18_attrezzature: 0,
        K19_macchinari: 0,
        K20_mobili: 0,
        K21_furgoni: 0,
        K22_autovetture: 0,
        K23_immateriali: 0,
        K24_altro: 0,
        K25_totale: 0
    },
    // contoEconomico: {
    // },
    contoEconomicoProfessionista: {
        J97_contributi_previdenziali: 0,
        G94_irpef_addizionali: 0,
        G93_irap: 0,
        //D86_Altro_Descrizione: "",
        J70_Compensi: 0,
        J73_Dipendenti: 0,
        J74_Compensi_Terzi: 0,
        G77_Riparazioni: 0,
        G79_Servizi_Contabili: 0,
        J94_totale: 0,
        G76_Energia: 0,
        G80_Spese_Telefoniche: 0,
        G81_Affitto_Locali: 0,
        G82_Assicurazioni: 0,
        G83_Agg_Profess: 0,
        G84_Carburanti: 0,
        G85_Interessi_Passivi: 0,
        G86_Altro_Valore: 0,
        J88_Totale_Costi: 0,
        J90_Risultato_Netto: 0,
        J99_Reddito_Disponibile: 0
    },
    // forfetario: {
    // },
    iscrizioneRegistroImprese: {
        J10_su_supporto_informatico_digitale: 120,
        I10_su_supporto_informatico_digitale: false,
        J11_con_modalita_telematica: 90,
        I11_con_modalita_telematica: false,
        I13_riduzione_del_50_per_le_cooperative_sociali: false,
        I15_maggiorazione: false,
        J15_maggiorazione: 15,
        I18_imposta_di_bollo_societa_di_capitali: false,
        J18_imposta_di_bollo_societa_di_capitali: 65,
        I17_imposta_di_bollo_societa_di_persone: false,
        J17_imposta_di_bollo_societa_di_persone: 59,
        J20_altro: 0,
        I24_su_supporto_informatico_digitale_o_per_via_telematica: false,
        J24_su_supporto_informatico_digitale_o_per_via_telematica: 18,
        I26_maggiorazione: false,
        J26_maggiorazione: 9,
        I28_imposta_di_bollo: false,
        J28_imposta_di_bollo: 17.50,
        J30_altro: 0
    },
    iscrizioneImpreseArtigiane: {
        J40_digita_importo: 0,
        I42_maggiorazione_per_impresa_individuale: false,
        J42_maggiorazione_per_impresa_individuale: 9,
        I43_maggiorazione_per_societa: false,
        J43_maggiorazione_per_societa: 15,
        J45_altro: 0,
        C45_altro: ""
    },
    contoEconomicoDittaSocieta: {
        tipologia_inail: "Non definito",
        J59_reddito_disponibile: 0,
        J48_totale: 0,
        J50_risultato_netto: 0,
        J44_risultato_operativo: 0,
        J42_affitto_figurativo: 0,
        J41_totale: 0,
        G40_diritto_ann_cciaa: 0,
        G39_inail: 0,
        G38_quote_associative: 0,
        G37_illuminazione: 0,
        G36_assicurazioni: 0,
        G35_affitto_uffici: 0,
        G34_spese_telefoniche: 0,
        G33_compenso_agli_amministratori: 0,
        G32_servizi_contabili: 0,
        J30_impiegati_salari_contrib_ecc: 0,
        J26_margine_della_produzione: 0,
        J24_totale_costi_diretti_della_produzione: 0,
        J22_totale: 0,
        D22_altro: "",
        G22_altro: 0,
        G20_energia_fm_combustibili_ecc: 0,
        G21_manutenzioni_riparazioni: 0,
        J10_ricavi_della_produzione_servizio: 0,
        J13_costo_dei_beni_impiegati_per_produrre_i_ricavi: 0,
        J14_mano_d_opera_salari_contr_ecc: 0,
        J15_salario_figurativo_titolare_soci_collaboratori: 0,
        J16_spese_per_lavorazioni_presso_terzi: 0,
        G19_affitto_locali_produzione: 0,
        G41_altro: 0,
        D41_altro: "",
        G48_interessi_attivi_cc_titoli_ecc: 0,
        G47_interessi_passivi_cc_mutui_ecc: 0,
        J57_contributi_previdenziali_titolare_collaboratori_soci: 0,
        J55_totale: 0,
        G55_irpef_addizionali: 0,
        G54_ires: 0,
        G53_irap: 0,
    },
    inail: {
        C19_classe_di_rischio: 0,
        D19_n_persone_assicurate: 1,
        E19_premio_inail: 0,
        D27_n_persone_assicurate: 1,
        //C27_tassox1000: 5.25,
        C27_tassox1000: 0,
        E27_premio_inail: 0,
        // ArtigianoIndustria: "Non definito",
    },
    dirittiCCIAA: {
        B8_check: false,
        B9_check: false,
        B10_check: false,
        B11_check: false,
        B12_check: false,
        B13_check: false,
        B14_check: false,
        B15_check: false,

        H8_sede_principale: 44,
        H9_sede_principale: 100,
        H10_sede_principale: 50,
        H11_sede_principale: 100,
        H12_sede_principale: 100,
        H13_sede_principale: 100,
        H14_sede_principale: 100,
        H15_sede_principale: 0,

        I8_maggiorazione: 0,
        I9_maggiorazione: 0,
        I10_maggiorazione: 0,
        I11_maggiorazione: 0,
        I12_maggiorazione: 0,
        I13_maggiorazione: 0,
        I14_maggiorazione: 0,

        J8_numero_unita_locali: 0,
        J9_numero_unita_locali: 0,
        J10_numero_unita_locali: 0,
        J11_numero_unita_locali: 0,
        J12_numero_unita_locali: 0,
        J13_numero_unita_locali: 0,
        J14_numero_unita_locali: 0,

        M16_totale: 0,
    },
    imposteContributi: {
        H62_irap: 0,
        J214_aliquota_ires: 24,
        F215_quota5socio: 0,
        F214_quota4socio: 0,
        F213_quota3socio: 0,
        F212_quota2socio: 0,
        F211_quota1socio: 0,
        F208_artigiano: false,
        F209_commerciante: false,
        F210_NOIVS: false,
        J165_pfigli: 0,
        I165_nfigli: 0,
        H165_coniuge: false,
        J164_pfigli: 0,
        I164_nfigli: 0,
        H164_coniuge: false,
        J163_pfigli: 0,
        I163_nfigli: 0,
        H163_coniuge: false,
        J162_pfigli: 0,
        I162_nfigli: 0,
        H162_coniuge: false,
        J161_pfigli: 0,
        I161_nfigli: 0,
        H161_coniuge: false,
        F166_totale: 0,
        C164_no_contributi: false,
        F164_quota_socio: 0,
        F165_quota_socio: 0,
        C165_no_contributi: false,
        F163_quota_socio: 0,
        C163_no_contributi: false,
        F162_quota_socio: 0,
        C162_no_contributi: false,
        F161_quota_socio: 0,
        C161_no_contributi: false,
        F157_nsoci: 0,
        F155_commerciante: false,
        F154_artigiano: false,
        J111_pfigli: 0,
        I111_nfigli: 0,
        H111_coniuge: false,
        J110_pfigli: 0,
        I110_nfigli: 0,
        H110_coniuge: false,
        J109_pfigli: 0,
        I109_nfigli: 0,
        H109_coniuge: false,
        J108_pfigli: 0,
        I108_nfigli: 0,
        H108_coniuge: false,
        H107_coniuge: false,
        J107_pfigli: 0,
        I107_nfigli: 0,
        RicalcolaQuoteCollab: false,
        RicalcolaQuoteSoci: false,
        F112_totale: 0,
        F111_quota_collab: 0,
        F110_quota_collab: 0,
        F109_quota_collab: 0,
        F108_quota_collab: 0,
        C111_21anni: false,
        C110_21anni: false,
        C109_21anni: false,
        C108_21anni: false,
        F107_quota_titolare: 0,
        F103_ncollaboratori: 0,
        F101_commerciante: false,
        F100_artigiano: false,
        J83_detrazioni: 0,
        H83_imposta_lorda: 0,
        F83_imponibile: 0,
        D83_contributi: 0,
        G80_con_cassa_autonoma: 0,
        F80_con_cassa_autonoma: false,
        H78_coniuge: false,
        J78_pfigli: 0,
        I78_nfigli: 0,
        F78_senzacassaal2598: false,
        F77_senzacassaal24: false,
        J69_pfigli: 0,
        I69_nfigli: 0,
        H69_coniuge: false,
        F69_commerciante: false,
        F68_artigiano: false,
        H59_irap: 0,
        E62_imponibile_irap: 0,
        E59_imponibile_irap: 0,
        H61_deduzioni: 0,
        H58_deduzioni: 0,
        E61_valore_della_produzione: 0,
        E58_valore_della_produzione: 0,
        F55_aliquota: 0,
        F53_assenza_di_autonoma_organizzazione: false,
        J45_reddito_ai_fini_fiscali_e_contributivi: 0,
        J44_reddito_ai_fini_fiscali_e_contributivi: 0,
        J84_irpef_netta: 0,
        J85_addiz_reg_com: 0,
        J89_totale: 0,
        D90_contributi: 0,
        F90_imponibile: 0,
        H90_imposta_lorda: 0,
        J91_irpef_netta: 0,
        J92_addiz_reg_com: 0
    },
    dettagli: {
        E7_contributi: 0,
        D7_quota: 0,
        F7_irpef_add: 0,
        F8_irpef_add: 0,
        E8_contributi: 0,
        D8_quota: 0,
        F10_irpef_add: 0,
        E10_contributi: 0,
        D10_quota: 0,
        F9_irpef_add: 0,
        E9_contributi: 0,
        D9_quota: 0,
        F11_irpef_add: 0,
        E11_contributi: 0,
        D11_quota: 0,
        F12_irpef_add: 0,
        E12_contributi: 0,
        D12_quota: 0,
        F17_irpef_add: 0,
        E17_contributi: 0,
        D17_quota: 0,
        F18_irpef_add: 0,
        E18_contributi: 0,
        D18_quota: 0,
        F20_irpef_add: 0,
        E20_contributi: 0,
        D20_quota: 0,
        F19_irpef_add: 0,
        E19_contributi: 0,
        D19_quota: 0,
        F22_irpef_add: 0,
        E22_contributi: 0,
        D22_quota: 0,
        F21_irpef_add: 0,
        E21_contributi: 0,
        D21_quota: 0,
        E27_contributi: 0,
        D27_quota: 0,
        E28_contributi: 0,
        D28_quota: 0,
        D29_quota: 0,
        E29_contributi: 0,
        D30_quota: 0,
        E30_contributi: 0,
        E31_contributi: 0,
        D31_quota: 0,
        E32_contributi: 0,
        D32_quota: 0
    },
    forfetari: {
        gruppoDiSettore : {
            D46_reddito: 0,
            gruppo: "Non definito",
        },
        tipologia : "NON DEFINITO",
        // B22_artigiano: false,
        B23_B26_riduzione_35: false,
        // B25_commerciante: false,
        B28_professionista_senza_cassa_al_24: false,
        B29_professionista_senza_cassa_al_25_72: false,
        B30_professionista_con_cassa_autonoma: false,
        altriDati: "",
        B32_impostaSostitutiva: false,
        B34_impresa_familiare_1_collaboratore: false,
        B35_rivalsa_contributi_ivs: false,
        D30_professionista_con_cassa_autonoma_percentuale: 0,
        D56_ricavi_compensi: 0,
        D58_reddito: 0,
        D60_contributi_previdenziali: 0,
        D62_rivalsa_contributi: 0,
        D64_imponibile: 0,
        D66_imposta_sostitutiva: 0,
        D69_diritto_annuale_cciaa: 0,
        D70_inail: 0,
        D72_totale_imposta_contributi_oneri: 0,
        D74_reddito_netto_disponibile: 0,
        C49_altri_dati: "",
        C50_altri_dati: "",
        C51_altri_dati: "",
        C52_altri_dati: "",
        C53_altri_dati: "",
        D94: 0,
        D95: 0,
        D96: 0,
        D97: 0,
    }
}

export const initialStateSimulazioniSrl: SimulazioniSrlDataClass = {
    loading: false,
    id: 0,
    datiSimulazioniSrl: {
        IDSocieta: "",
        M198: 0,
        M196: "Non definito",
        J198: 0,
        J197: 0,
        J196: false,
        L194: 0,
        L193: 0,
        N192: 0,
        L191: 0,
        J191: 0,
        H191: false,
        E199: 0,
        E197: 0,
        E196: 0,
        E195: 0,
        E194: 0,
        E193: 0,
        E192: 0,
        E191: 0,
        E190: 0,
        M184: 0,
        M182: "Non definito",
        J184: 0,
        J183: 0,
        J182: false,
        L180: 0,
        L179: 0,
        N178: 0,
        L177: 0,
        J177: 0,
        H177: false,
        E185: 0,
        E183: 0,
        E182: 0,
        E181: 0,
        E180: 0,
        E179: 0,
        E178: 0,
        E177: 0,
        E176: 0,
        M169: 0,
        M167: "Non definito",
        J169: 0,
        J168: 0,
        J167: false,
        L165: 0,
        L164: 0,
        N163: 0,
        L162: 0,
        J162: 0,
        H162: false,
        E170: 0,
        E168: 0,
        E167: 0,
        E166: 0,
        E165: 0,
        E164: 0,
        E163: 0,
        E162: 0,
        E161: 0,
        M155: 0,
        M153: "Non definito",
        J155: 0,
        J154: 0,
        J153: false,
        L151: 0,
        L150: 0,
        N149: 0,
        L148: 0,
        J148: 0,
        H148: false,
        E156: 0,
        E154: 0,
        E153: 0,
        E152: 0,
        E151: 0,
        E150: 0,
        E149: 0,
        E148: 0,
        E147: 0,
        M139: "Non definito",
        J139: false,
        M141: 0,
        J141: 0,
        J140: 0,
        L137: 0,
        L136: 0,
        N135: 0,
        E142: 0,
        E140: 0,
        E139: 0,
        E138: 0,
        E137: 0,
        E136: 0,
        E135: 0,
        E134: 0,
        E133: 0,
        L119: 0,
        J119: 0,
        H119: false,
        G48: "",
        C52: "",
        K52: 0,
        K53: 0,
        C53: "",
        K54: 0,
        C54: "",
        K55: 0,
        C55: "",
        K56: 0,
        C56: "",
        K57: 0,
        C57: "",
        K62: 0,
        K63: 0,
        K64: 0,
        D65: aliquotaIRES,
        D72: 0,
        G74: 0,
        G75: 0,
        G76: 0,
        G77: 0,
        G78: 0,
        G79: 0,
        D83: 0,
        D88: 0,
        D89: 0,
        G91: 0,
        G92: 0,
        G93: 0,
        G94: 0,
        G95: 0,
        G96: 0,
        G104: 0,
        G105: 0,
        G106: 0,
        G107: 0,
        G108: 0,
        G109: 0,
        D102: 0,
        E111: 0,
        L52: "",
        H74: "",
        H91: "",
        H104: "",
        J111: false,
        H134: false,
        E127: 0,
        E125: 0,
        E124: 0,
        E123: 0,
        E122: 0,
        E121: 0,
        E120: 0,
        E119: 0,
        E118: 0,
        J134: 0,
        L134: 0,
        N120: 0,
        L121: 0,
        L122: 0,
        J124: false,
        J126: 0,
        J125: 0,
        M124: "Non definito",
        M126: 0
    },
    normaleSimulazioniSrl: {
        I97: 0,
        I99: 0,
        I11: 0,
        I12: 0,
        I13: 0,
        I14: 0,
        E38: 0,
        E39: 0,
        G23: 0,
        H23: 0,
        K37: 0,
        M37: 0,
        I35: 0,
        I37: 0,
        I33: 0,
        I31: 0,
        I30: 0,
        I29: 0,
        I27: 0,
        I26: 0,
        I25: 0,
        I56: 0,
        I57: 0,
        I58: 0,
        I60: 0,
        I61: 0,
        I62: 0,
        I64: 0,
        I66: 0,
        I68: 0,
        M68: 0,
        K68: 0,
        H54: 0,
        G54: 0,
        E69: 0,
        E70: 0,
        E73: 0,
        E100: 0,
        E101: 0,
        G85: 0,
        H85: 0,
        I87: 0,
        I88: 0,
        I89: 0,
        I91: 0,
        I92: 0,
        I93: 0,
        I95: 0,
        K99: 0,
        M99: 0,
        I34: 0,
        I65: 0,
    },
    soloCompSimulazioniSrl: {
        M98: 0,
        K98: 0,
        I98: 0,
        I96: 0,
        I94: 0,
        I92: 0,
        I91: 0,
        I90: 0,
        I88: 0,
        I87: 0,
        I86: 0,
        H84: 0,
        G84: 0,
        E100: 0,
        E99: 0,
        E87: 0,
        D87: 0,
        M67: 0,
        K67: 0,
        I67: 0,
        I65: 0,
        I63: 0,
        I61: 0,
        I60: 0,
        I59: 0,
        I57: 0,
        I56: 0,
        I55: 0,
        H53: 0,
        G53: 0,
        E69: 0,
        E68: 0,
        E56: 0,
        D56: 0,
        M36: 0,
        K36: 0,
        I36: 0,
        I34: 0,
        I32: 0,
        I30: 0,
        I29: 0,
        I28: 0,
        I26: 0,
        I25: 0,
        I24: 0,
        H22: 0,
        G22: 0,
        E38: 0,
        E37: 0,
        E25: 0,
        D25: 0,
        I14: 0,
        I13: 0,
        I11: 0,
        I8: 0
    },
    compDivSimulazioniSrl: {
        M37: 0,
        K37: 0,
        M33: 0,
        K33: 0,
        I37: 0,
        I35: 0,
        I33: 0,
        I31: 0,
        I30: 0,
        I29: 0,
        I27: 0,
        I26: 0,
        I25: 0,
        H23: 0,
        G23: 0,
        M25: 0,
        E39: 0,
        E38: 0,
        E31: 0,
        E26: 0,
        D26: 0,
        I14: 0,
        I13: 0,
        I11: 0,
        I8: 0,
        D57: 0,
        E57: 0,
        E62: 0,
        E69: 0,
        I93: 0,
        I92: 0,
        I91: 0,
        I89: 0,
        I88: 0,
        I87: 0,
        H85: 0,
        G85: 0,
        E101: 0,
        E100: 0,
        E93: 0,
        E88: 0,
        D88: 0,
        M68: 0,
        K68: 0,
        E70: 0,
        G54: 0,
        H54: 0,
        I56: 0,
        I57: 0,
        I58: 0,
        I60: 0,
        I61: 0,
        I62: 0,
        I64: 0,
        I66: 0,
        I68: 0,
        M56: 0,
        K64: 0,
        M64: 0,
        M99: 0,
        K99: 0,
        M95: 0,
        K95: 0,
        M87: 0,
        I99: 0,
        I97: 0,
        I95: 0,
    },
    traspSimulazioniSrl: {
        M37: 0,
        K37: 0,
        I37: 0,
        I35: 0,
        I33: 0,
        I31: 0,
        I30: 0,
        I29: 0,
        I27: 0,
        I26: 0,
        I25: 0,
        H23: 0,
        G23: 0,
        E39: 0,
        E38: 0,
        E32: 0,
        I11: 0,
        M100: 0,
        K100: 0,
        I100: 0,
        I98: 0,
        I96: 0,
        I94: 0,
        I93: 0,
        I92: 0,
        I90: 0,
        I89: 0,
        I88: 0,
        H86: 0,
        G86: 0,
        E101: 0,
        E102: 0,
        E95: 0,
        M69: 0,
        K69: 0,
        I69: 0,
        I67: 0,
        I65: 0,
        I63: 0,
        I62: 0,
        I61: 0,
        I59: 0,
        I58: 0,
        I57: 0,
        H55: 0,
        G55: 0,
        E71: 0,
        E70: 0,
        E64: 0,
    },
    soloDivSimulazioniSrl: {
        K37: 0,
        M37: 0,
        M33: 0,
        K33: 0,
        M25: 0,
        I37: 0,
        I35: 0,
        I31: 0,
        I33: 0,
        I30: 0,
        I29: 0,
        I27: 0,
        I26: 0,
        I25: 0,
        H23: 0,
        G23: 0,
        E39: 0,
        E38: 0,
        E31: 0,
        I14: 0,
        I13: 0,
        I11: 0,
        M99: 0,
        K99: 0,
        M95: 0,
        K95: 0,
        M87: 0,
        I99: 0,
        I97: 0,
        I95: 0,
        I93: 0,
        I92: 0,
        I91: 0,
        I89: 0,
        I88: 0,
        I87: 0,
        H85: 0,
        G85: 0,
        E101: 0,
        E100: 0,
        E93: 0,
        M68: 0,
        K68: 0,
        M64: 0,
        K64: 0,
        M56: 0,
        I68: 0,
        I66: 0,
        I64: 0,
        I62: 0,
        I61: 0,
        I60: 0,
        I58: 0,
        I57: 0,
        I56: 0,
        H54: 0,
        G54: 0,
        E70: 0,
        E69: 0,
        E62: 0,
    },
    traspCompSimulazioniSrl: {
        M98: 0,
        K98: 0,
        I98: 0,
        I96: 0,
        I94: 0,
        I92: 0,
        I91: 0,
        I90: 0,
        I88: 0,
        I87: 0,
        I86: 0,
        H84: 0,
        G84: 0,
        E100: 0,
        E99: 0,
        E87: 0,
        D87: 0,
        E93: 0,
        I59: 0,
        I60: 0,
        I61: 0,
        I63: 0,
        I65: 0,
        I67: 0,
        M67: 0,
        K67: 0,
        I57: 0,
        I56: 0,
        I55: 0,
        H53: 0,
        G53: 0,
        E69: 0,
        E68: 0,
        E62: 0,
        E56: 0,
        D56: 0,
        M36: 0,
        K36: 0,
        I36: 0,
        I34: 0,
        I32: 0,
        I30: 0,
        I29: 0,
        I28: 0,
        I26: 0,
        I25: 0,
        I24: 0,
        H22: 0,
        G22: 0,
        E38: 0,
        E37: 0,
        E31: 0,
        E25: 0,
        D25: 0,
        I12: 0,
        I11: 0,
        I8: 0
    },
    riepilogoSimulazioniSrl: {
        N93: 0,
        N94: 0,
        N95: 0,
        L93: 0,
        J93: 0,
        I93: 0,
        H93: 0,
        G93: 0,
        N89: 0,
        N88: 0,
        N87: 0,
        N63: 0,
        N62: 0,
        N61: 0,
        L61: 0,
        K61: 0,
        J61: 0,
        I61: 0,
        H61: 0,
        G61: 0,
        N57: 0,
        N56: 0,
        N55: 0,
        N54: 0,
        N46: 0,
        N45: 0,
        N44: 0,
        L44: 0,
        K44: 0,
        J44: 0,
        I44: 0,
        H44: 0,
        N40: 0,
        N39: 0,
        N38: 0,
        N30: 0,
        N29: 0,
        N28: 0,
        L28: 0,
        J28: 0,
        I28: 0,
        H28: 0,
        G28: 0,
        N24: 0,
        N23: 0,
        N22: 0,
        N21: 0,
        N15: 0,
        N14: 0,
        N13: 0,
        L13: 0,
        J13: 0,
        I13: 0,
        H13: 0,
        N9: 0,
        N8: 0,
        N7: 0,
        N71: 0,
        N73: 0,
        N72: 0,
        L77: 0,
        J77: 0,
        I77: 0,
        H77: 0,
        N77: 0,
        N78: 0,
        N79: 0
    }
}

export default function initializeGlobalState(development: boolean) {
    console.log('Initialize Global state');
    const path = window.location.pathname;
    // console.log('Initialize Global state path: ' + path);
    if (!development && path.indexOf('/callback') > -1) {
        setGlobal({...initialGlobalState, loadingAuth: true });
    } else {
        setGlobal(initialGlobalState);
    }
    addReducers();
}